import Image from 'next/image';
import { FC, useState } from 'react';

import Modal from '~components/ui/Modal';
import ShadowImage from '~components/ui/ShadowImage';

import { Attachment } from '~types';

import s from './Gallery.module.css';

interface Props {
  images: Attachment[];
}

const Gallery: FC<Props> = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState<Attachment>();
  return (
    <>
      <div className={s.root}>
        {images.map((image) => (
          <a href="#" onClick={() => setSelectedImage(image)} key={image.tmpDir}>
            <ShadowImage data={image} className={s.img} version="url" />
          </a>
        ))}
      </div>
      <Modal onClose={() => setSelectedImage(undefined)} open={!!selectedImage}>
        <div className="relative aspect-video w-[calc(100vw_-_32px)] max-w-[1024px] overflow-hidden rounded-xl bg-black">
          {!!selectedImage && (
            <Image src={selectedImage.url} fill className="object-cover" alt="" />
          )}
        </div>
      </Modal>
    </>
  );
};

export default Gallery;
